(ns frontend.ui.component.lp-portal.report.body.feeder.feeder.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))


(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  {:fund-name      (:fund-name report-data)
   :reference-date (:reference-date report-data)
   :basic-information-primary (report-ctl/with-footnote
                               props
                               :basic-information-primary-footnotes
                               (get-in report-data
                                       [:basic-information-primary]))
   :basic-information-secondary (report-ctl/with-footnote
                                 props
                                 :basic-information-secondary-footnotes
                                 (get-in report-data
                                         [:basic-information-secondary]))
   :overview       (report-ctl/rich-content props
                                            :overview-text)
   :summary        (report-ctl/with-footnote
                    props
                    :summary-footnotes
                    (get-in report-data [:summary]))
   :investors      (report-ctl/with-footnote
                    props
                    :investors-footnotes
                    (get-in report-data [:investors]))})